import { ListCard, SkeletonItem } from '@capsicum/common-web';
import { ChevronRightIcon } from '@capsicum/common-web/icons';
import { useTheme } from 'styled-components';

import * as Components from './styled';

export const NCWalletTokenListCardSkeleton = () => {
	const { colors } = useTheme();

	return (
		<Components.ListCardWrapper>
			<ListCard.Start>
				<ListCard.Image isLoading src="" />
			</ListCard.Start>
			<Components.ContentWrapper $clickable={false}>
				<ListCard.Content>
					<ListCard.Row>
						<Components.ListCardTitle>
							<SkeletonItem height={20} width={128} />
						</Components.ListCardTitle>
						<Components.ListCardText>
							<SkeletonItem height={20} width={64} />
						</Components.ListCardText>
					</ListCard.Row>
					<ListCard.ContentDivider />
					<ListCard.Row>
						<Components.ListCardTitle>
							<SkeletonItem width={128} />
						</Components.ListCardTitle>
						<Components.ListCardText>
							<SkeletonItem height={14} width={128} />
						</Components.ListCardText>
					</ListCard.Row>
				</ListCard.Content>
				<Components.ListCardEndTop>
					<ChevronRightIcon color={colors.transparent} height={20} width={20} />
				</Components.ListCardEndTop>
			</Components.ContentWrapper>
		</Components.ListCardWrapper>
	);
};
